<template>
  <v-container>
    <v-card flat>
      <!-- Used to display company employee permissions -->
      <CompanyEmployeeList nextTo="CompanyEmployeePermissions" nextIcon="$sl-permissions" type="employed" :title="$t('labels.permissions')"/>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyEmployeeList from '@/components/Company/CompanyEmployeeList'

// @group Company
// CompanyOrders component
export default {
  name: 'CompanyOrders',

  components: {
    CompanyEmployeeList
  },

  data: () => ({
    tab: null,

    apprentice: {}
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser'])
  },

  created() {}
}
</script>

<style lang="scss"></style>
